import { useAppSelector } from "../store/hooks";

/**
 * The name to show in the UI.
 *
 * Prefers the user's custom display name (stored in their profile), falling back
 * to the Auth0-authorized name. This is display-only: payments, billing, and
 * authorization always use the Auth0 identity resolved server-side, never this.
 */
export function useDisplayName(): string {
  const displayName = useAppSelector((s) => s.profile.displayName);
  const authName = useAppSelector((s) => s.auth.user?.name);
  return (displayName && displayName.trim()) || authName || "";
}
